export default __webpack_public_path__ + "static/media/curtains.57552f75.png";